import { LanguageCode } from 'mytours-read-api-typescript'
import { languageCodes } from 'mobile_web/strings'
import { history } from './history'

declare const baseAppPath: string

export const isAvailableLanguage = (locale: LanguageCode) => languageCodes.includes(locale)

export const replaceLanguageCodeInPathname = (
	supportedLanguages: LanguageCode[],
	languageCode: LanguageCode,
): string => {
	const splittedPathname = history.location.pathname.replace(baseAppPath, '').split('/')

	if (splittedPathname.length === 1 && !splittedPathname[0]) {
		// check if pathname has first param
		splittedPathname[1] = languageCode
	} else if (
		isAvailableLanguage(splittedPathname[1] as LanguageCode) &&
		supportedLanguages.includes(splittedPathname[1] as LanguageCode)
	) {
		// check if first param is language code
		splittedPathname[1] = languageCode
	} else if (splittedPathname.length === 2 && !splittedPathname[2]) {
		// if first param isn't language code then check if second param is language code
		splittedPathname.splice(1, 0, languageCode)
	} else if (!isAvailableLanguage(splittedPathname[1] as LanguageCode)) {
		// if first param isn't language code then just insert language code
		splittedPathname.splice(1, 0, languageCode)
	} else if (!supportedLanguages.includes(splittedPathname[1] as LanguageCode)) {
		// if language code is not in supported languages then just delete language param
		delete splittedPathname[1]
	}

	return baseAppPath + splittedPathname.filter(param => param !== null).join('/')
}

export const getLanguageCodeFromUrl = (supportedLanguages: LanguageCode[]): LanguageCode | undefined => {
	const splittedPathname = history?.location?.pathname?.replace(baseAppPath, '').split('/')

	if (!splittedPathname || (splittedPathname.length === 1 && !splittedPathname[0])) {
		// check if pathname has first param
		return undefined
	} else if (
		isAvailableLanguage(splittedPathname[1] as LanguageCode) &&
		supportedLanguages.includes(splittedPathname[1] as LanguageCode)
	) {
		// check if first param is language code
		return splittedPathname[1] as LanguageCode
	}

	return undefined
}
